import { useQuery } from "@apollo/client";

import { PlannerV2VisitGetByIdDocument } from "../queries.generated";

export default function usePlannerV2VisitGetById(params: { onDate: string; plannerVisitId: string; timeslotId?: string }) {
    const { data, loading, error, previousData } = useQuery(PlannerV2VisitGetByIdDocument, {
        variables: params,
        errorPolicy: "all",
    });

    const result = data ?? previousData;

    return {
        loading,
        error,
        data: {
            visit: result?.plannerV2VisitGetById,
            plannedOnDates: result?.plannerV2VisitGetPlannedOnDates,
            possibleTimeslots: result?.plannerV2VisitGetPossibleTimes,
            travelGroups: result?.plannerV2TravelGroupsGetAttendingVisit?.map(attendance => attendance.plannerTravelGroup),
            mapElements: result?.plannerV2MapElementsGetByPlannerVisitId,
        },
    };
}
